import React from "react";
import {
  ToastContainer,
  toast,
  cssTransition,
  ToastOptions,
  TypeOptions as ToastType,
  ToastPosition,
  Theme
} from "react-toastify";

// css goes to assets/js/filename.css
import "animate.css/animate.min.css";
import "react-toastify/dist/ReactToastify.css";

const flipIn = cssTransition({
  enter: "animate__animated animate__flipInX",
  exit: "animate__animated animate__bounceOut",
});

export const notify = (text: React.ReactNode, type: ToastType, opts: ToastOptions = {}) => {
  const default_opts = {
    position: "top-right" as ToastPosition,
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false, //click x to close when false
    pauseOnHover: true,
    draggable: true, //drag to close
    progress: undefined,
    theme: "colored" as Theme, //light dark colored
    type: type || "default", //info success warning error default
    transition: flipIn,
  };

  opts = { ...default_opts, ...opts };

  toast(text, opts);
};

// wraps the 3rd party lib for substitution
function Notifications() {
  // needed for toast func above to render
  return <ToastContainer />;
}

export default Notifications;
